import Cookies from 'js-cookie';

export async function defaultFetcher(resource, init = {}) {
  const { headers, ...otherInit } = init;

  const res = await fetch(resource, {
    ...otherInit,
    headers: {
      Accept: 'application/json',
      ...headers,
    },
  });

  if (res.ok) {
    return await res.json();
  } else {
    throw new Error('Error during fetch!\n' + JSON.stringify(await res.json()));
  }
}

export async function defaultMutator(resource, init = {}) {
  const { arg, headers: customHeaders = {}, ...otherInit } = init;

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...customHeaders,
  };

  try {
    const res = await fetch(resource, {
      method: 'POST', // default can be overridden by `otherInit`
      headers,
      body: JSON.stringify(arg),
      ...otherInit, // additional options like `method` or `credentials`
    });

    // non-OK responses
    if (!res.ok) {
      const error = new Error('Request failed');
      error.status = res.status;
      error.data = await res.json().catch((err) => console.error(err));
      throw error;
    }

    return await res.json();
  } catch (err) {
    // network or unexpected errors
    if (process.env.NODE_ENV === 'development') {
      console.error('defaultMutator error:', err);
    }
    throw err;
  }
}
